import './careers.css';
import React from 'react';

const HardwareText = () => {
  return (
    <p className="text">
      Our proprietary wireless in-car hardware transmits real-time vehicle
      health and driver behavior data to ensure the safety of our users,
      optimize recharging time, minimize grid load and maximize vehicle
      utilization.
    </p>
  );
};

export default HardwareText;



// WEBPACK FOOTER //
// ./src/components/Careers/HardwareText.js